import {React, _n} from 'pexui';
import { Link } from '../comps/uicomps';

export class ExpandableFAQ extends React.Component {
  constructor(props) {
    super(props);
    this.index = props.index;
    this.previewCount = props.previewCount;
    this.question = props.item.question;
    this.answer = props.item.answer;
    this.windowHandler = props.windowHandler;
  }

  expandAnswer(elementId) {
    if (!this.windowHandler) 
        return;

    const answerDiv = this.windowHandler.document.getElementById(elementId);
    if (!answerDiv) 
        return;
      
    const formattedContent = this.answer.map(ans => `<p>${ans}</p>`).join('')
    answerDiv.innerHTML = `<p>${formattedContent}</p>`;
  }

  render() {
        return (<div className="infw-faq-item"
                style={{display: (this.previewCount && this.index >= this.previewCount)? "none": "block"}}>
            <Link id={ `faq_${this.index}` } className="infw-faq-question" label={ this.question } onClick={ () => this.expandAnswer(`answer_${this.index}`) }/>
            <div id={ `answer_${this.index}` } className="infw-faq-answer">
                {
                    this.answer.length === 1 && this.answer[0].length <= 100
                    ? this.answer[0] 
                    : this.answer[0].substr(0,100) + '...'
                }
            </div>
        </div>
      );
  }
};


// WEBPACK FOOTER //
// ./application/src/views/comps/ExpandableFAQ.jsx